import type { CustomizationColor } from './CustomizationContext'

export const DEFAULT_PRIMARY_COLOR = '#0085FF'

export const DEFAULT_COLORS: CustomizationColor = {}
